import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { AppState } from '@app/reducers';
import { CrudService, CrudType, currentComponentPageBasedPermissionsSelector$, fileUrlDownload, IApplicationResponse, ModulesBasedApiSuffix, PERMISSION_RESTRICTION_ERROR, prepareDynamicTableTabsFromPermissions, prepareRequiredHttpParams, ResponseMessageTypes, RxjsService, SnackbarService } from '@app/shared';
import { INVENTORY_COMPONENT, InventoryModuleApiSuffixModels } from '@modules/inventory/shared';
import { loggedInUserData } from '@modules/others';
import { UserLogin } from '@modules/others/models';
import { select, Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { BarcodePrintComponent } from '../order-receipts/barcode-print';
@Component({
  selector: 'app-stock-maintenance-view',
  templateUrl: './stock-maintenance-view.component.html',
  styleUrls: ['./stock-maintenance-view.component.scss']
})
export class StockMaintenanceViewComponent implements OnInit {
  stockId;
  userData: any;
  selectedTabIndex = 0;
  stockMaintenancesDetail: any = {};
  stockMaintenancesWarehouseDetail;
  stockMaintenancesThresholdDetail;
  stockMaintenancesSkillMappingDetail = {
    systemTypeName: null,
    systemTypeSubCategoryName: null,
    jobTypeName: null
  };
  breadCrumbTitle = "product - maintenance";
  productSkillArray: any;
  stockMaintainanceHeaderImage: any;
  headerImageUrl: string = './assets/img/upload.png';
  productWarehouseDetails: any = {};
  sellableList = [{ value: true, display: 'Yes' }, { value: false, display: 'No' }];
  costSource: string = '';
  barcodes: any = [];
  documents = [];
  isSaveMaintenance: boolean = true;
  isShowRepairCode: boolean = false;
  isThresholdDisable: boolean = false;
  primengTableConfigProperties: any;
  loggedInUserData;
  condition;
  constructor(
    private crudService: CrudService, private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef, private dialog: MatDialog, private snackbarService: SnackbarService,
    private router: Router, private rxjsService: RxjsService, private store: Store<AppState>) {
    this.stockId = this.activatedRoute.snapshot.queryParams.id;
    this.store.pipe(select(loggedInUserData)).subscribe((userData: UserLogin) => {
      this.userData = userData;
    });
    this.primengTableConfigProperties = {
      tableCaption: "Stock Maintenance",
      selectedTabIndex: 0,
      breadCrumbItems: [{ displayName: 'Inventory Management', relativeRouterUrl: '/inventory/dashboard' },{  displayName:'Stock & Warehouse Management',relativeRouterUrl: ''}, { displayName: 'Stock Maintenance List', relativeRouterUrl: '/inventory/stock-maintenance' }, { displayName: 'Stock Maintenance View :' + this.breadCrumbTitle.toLocaleUpperCase(), relativeRouterUrl: '' }],
      tableComponentConfigs: {
        tabsList: [
          {
            selectedTabIndex: 0,
            enableBreadCrumb: true,
            enableAction: true,
            enableEditActionBtn: true
          }
        ]
      }
    }
  }

  ngOnInit(): void {
    this.combineLatestNgrxStoreData();
    this.getStockMaintenanceDetails().subscribe((response: IApplicationResponse) => {
      this.stockMaintenancesDetail = response.resources;
      this.getPrintDetail();
      this.isSaveMaintenance = response.resources?.productMaintenance?.condition == null ? true : (response.resources?.productMaintenance?.condition === 'Refurbished' ? (response.resources?.productMaintenance?.newStockCodeid == null ? true : false) : false)
      if (this.stockMaintenancesDetail?.productSkillMapping.technicalSkillLeavel) {
        let skillDetails = this.stockMaintenancesDetail.productSkillMapping.technicalSkillLeavel
        this.productSkillArray = skillDetails?.split(',');
      }
      this.rxjsService.setGlobalLoaderProperty(false);
    });
    this.getWarehouseDocuments();  
    this.getProductWarehouseDetails().subscribe((response: IApplicationResponse) => {
      if (response.isSuccess && response.statusCode === 200) {
        this.productWarehouseDetails = response.resources;
        this.rxjsService.setGlobalLoaderProperty(false);
      }
    });
  }

  getPrintDetail(){
    this.getStockMaintenanceHeaderDetails().subscribe((response: IApplicationResponse) => {
      if (response.isSuccess && response.statusCode === 200) {
        this.stockMaintainanceHeaderImage = response.resources;
        this.isShowRepairCode = response.resources?.isRepairCode;
        this.condition = response.resources?.condition;
        this.isThresholdDisable =  response.resources?.condition == "Once Off" ? true : false;
        this.barcodes = new Array({isShow:true,stockCode : this.stockMaintenancesDetail?.stockCode,stockCodeBarcode:this.stockMaintainanceHeaderImage?.stockCodeBarcode,stockDescription : this.stockMaintenancesDetail?.stockDescription});
        // Pre-compute the image URL once when data is available
        if (this.stockMaintainanceHeaderImage?.imagePath) {
          this.updateHeaderImageUrl(this.stockMaintainanceHeaderImage.imagePath);
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      }
    });
  }

  updateHeaderImageUrl(documentPath: string): void {
    if (documentPath) {
      fileUrlDownload(documentPath, "default", false, this.crudService, this.rxjsService, false).then((url: string) => {
        this.headerImageUrl = url;
      }).catch(() => {
        this.headerImageUrl = './assets/img/upload.png';
      });
    } else {
      this.headerImageUrl = './assets/img/upload.png';
    }
  }

  getWarehouseDocuments() {
    this.crudService.get(ModulesBasedApiSuffix.INVENTORY, InventoryModuleApiSuffixModels.STOCK_MAINTENANCE_DOCUMENTS, undefined, false, prepareRequiredHttpParams({
      ItemId: this.stockId
    })).subscribe((response: IApplicationResponse) => {
      if (response.isSuccess && response.statusCode == 200) {
        this.documents = response.resources;
      }
    });
  }

  combineLatestNgrxStoreData() {
    combineLatest([
      this.store.select(currentComponentPageBasedPermissionsSelector$)]
    ).subscribe((response) => {
      let permission = response[0][INVENTORY_COMPONENT.STOCK_MAINTENANCE];
      if (permission) {
        let prepareDynamicTableTabsFromPermissionsObj = prepareDynamicTableTabsFromPermissions(this.primengTableConfigProperties, permission);
        this.primengTableConfigProperties = prepareDynamicTableTabsFromPermissionsObj['primengTableConfigProperties'];
      }
    });
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  onCRUDRequested(type: CrudType | string, row?: object, unknownVar?: any): void {
    switch (type) {
      case CrudType.EDIT:
        this.navigateToEdit();
        break;
    }
  }

  navigateToEdit() {
    if (!this.primengTableConfigProperties.tableComponentConfigs.tabsList[0].canEdit) {
      return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
    }
    this.router.navigate(['inventory/stock-maintenance/add-edit'], { queryParams: { id: this.stockId }, skipLocationChange: true });
  }

  getStockMaintenanceDetails(): Observable<any> {
    return this.crudService.get(ModulesBasedApiSuffix.INVENTORY, InventoryModuleApiSuffixModels.STOCK_MAINTENANCE_CONSOLIDATE, undefined, false, prepareRequiredHttpParams({
      UserId: this.userData.userId,
      ItemId: this.stockId
    }));
  }

  getProductWarehouseDetails(): Observable<any> {
    return this.crudService.get(ModulesBasedApiSuffix.INVENTORY, InventoryModuleApiSuffixModels.STOCK_MAINTENANCE_PRODUCT_WAREHOUSE_CONSOLIDATE, undefined, false, prepareRequiredHttpParams({
      ItemId: this.stockId
    }, { userId: this.userData.userId }));
  }

  getStockMaintenanceHeaderDetails(): Observable<any> {
    return this.crudService.get(ModulesBasedApiSuffix.INVENTORY, InventoryModuleApiSuffixModels.STOCK_MAINTENANCE, this.stockId, false);
  }

  onTabClicked(tab): void {
    this.selectedTabIndex = tab.index;
    this.breadCrumbTitle = tab.tab.textLabel;
    this.primengTableConfigProperties.breadCrumbItems = [{ displayName: 'Inventory Management', relativeRouterUrl: '/inventory/dashboard' },  {  displayName:'Stock & Warehouse Management',relativeRouterUrl: ''},{ displayName: 'Stock Maintenance List', relativeRouterUrl: '/inventory/stock-maintenance' }, { displayName: 'Stock Maintenance View :' + this.breadCrumbTitle?.toLocaleUpperCase(), relativeRouterUrl: '' }];
  }

  openBarcodeModal() {
    this.dialog.open(BarcodePrintComponent,
      {
        width: '400px', height: '400px', disableClose: true,
        data: { serialNumbers: new Array(this.stockMaintainanceHeaderImage?.stockCodeBarcode) }
      });
  }

  /** Opens document URL in a new tab (for Supporting Documents). Uses fileUrlDownload so blob URLs are handled correctly. */
  openDocumentInNewTab(docPath: string, docName: string, event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (docPath) {
      fileUrlDownload(docPath, docName || 'document', false, this.crudService, this.rxjsService, true, 'openInNewTab').catch(() => {
        this.snackbarService.openSnackbar('Unable to open document', ResponseMessageTypes.ERROR);
      });
    }
  }
}
